module.exports = __webpack_public_path__ + "static/media/test.a14c7cc2.svg";